import { render, staticRenderFns } from "./DtCourseTable.vue?vue&type=template&id=6a6cb651&"
import script from "./DtCourseTable.vue?vue&type=script&lang=js&"
export * from "./DtCourseTable.vue?vue&type=script&lang=js&"
import style0 from "./DtCourseTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports